module.exports = __webpack_public_path__ + "static/media/hipercard.f055c347.svg";